import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import color from 'tinycolor2';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import AccountHelper from 'Workspace/helpers/AccountHelper';
import {
  Avatar,
  SVGIcon,
} from '@pearsontechnology/aero-components';
import messages from './messages';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  line-height: 1.2;

  & > *:first-child {
    flex-shrink: 0;
  }

  & > *:not(:first-child) {
    margin-left: 8px;
  }
`;

const AllStudentsWrapper = styled.div`
  width: 26px;
  height: 26px;
  background-color: ${(props) => color(props.theme['color.primary']).setAlpha(0.2).toString()};
  color: ${(props) => props.theme['color.primary']};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AvatarCustomBackground = styled(Avatar)`
  background-color: ${(props) => color(props.theme['color.primary']).setAlpha(0.2).toString()};
  font-size: 12px;
  letter-spacing: 0.8px;
  line-height: 26px;
`;

function nameOrFullName(account) {
  if (account.name) {
    return account.name;
  }
  return AccountHelper.getFullName(account);
}

function givenNameAndFamilyName(account) {
  if (account.givenName && account.familyName) {
    const { givenName, familyName } = account;
    return { givenName, familyName };
  }
  if (account.name) {
    const split = account.name.split(/\s+/);
    const givenName = split[0];
    const familyName = split[1] ? split[1] : undefined;
    return { givenName, familyName };
  }
  return {};
}

function AccountSummaryNew({ account, allStudents }) {
  return (
    <Wrapper>
      {!allStudents ? (
        <AvatarCustomBackground
          avatar={{
            ...account,
            ...givenNameAndFamilyName(account),
            avatarSmall: account.avatarUrl,
          }}
          size={26}
          rgb={{ r: 0, g: 115, b: 202 }}
        />
      ) : (
        <AllStudentsWrapper>
          <SVGIcon icon="class" size={{ width: '18', height: '18' }} />
        </AllStudentsWrapper>
      )}
      <span>{!allStudents ? nameOrFullName(account) : intl.formatMessage(messages.allStudents)}</span>
    </Wrapper>
  );
}

AccountSummaryNew.propTypes = {
  account: PropTypes.object,
  allStudents: PropTypes.bool,
};

export default AccountSummaryNew;
